import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

const SingleFaq = ({ index, item }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="accordion-faq"
        id="accordion-faq"
      >
        {index + 1}. {item?.question}
      </AccordionSummary>
      <AccordionDetails>{item?.answer}</AccordionDetails>
    </Accordion>
  );
};

export default SingleFaq;
